const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // You could add additional logic to handle the form submission or validation here
    window.location.href = "mailto:johannesmnz@gmail.com";
  };

  return (
    <div id="contact" className="container">
      <h1>Contact Me</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Your Name:</label><br />
        <input type="text" id="name" name="name" required /><br /><br />

        <label htmlFor="email">Your Email:</label><br />
        <input type="email" id="email" name="email" required /><br /><br />

        <label htmlFor="subject">Subject:</label><br />
        <input type="text" id="subject" name="subject" required /><br /><br />

        <label htmlFor="message">Message:</label><br />
        <textarea id="message" name="message" rows="4" cols="50" required></textarea><br /><br />

        <input type="submit" value="Send" />
      </form>
    </div>
  );
};

export default Contact;